import { atom } from 'jotai';
import { type InventoryItem, SUBSCRIPTION_CATEGORY_IDS } from 'src/types/itemInventory';
import { uniqBy } from 'src/utils/array';
import { getAtomWithSessionStorage, getAtomWithStorage, reviveDateFromStorage } from 'src/utils/localStorageUtils';
export const LOCAL_STORAGE_KEY_LAST_NUDGE_TOAST_HAS_SHOWN_TIME = 'lastSubscriptionNudgeToastShownTime';
export const subscriptionHistoryAtom = getAtomWithStorage<InventoryItem[]>('subscriptionHistory', []);
export const accumulateSubscriptionHistoryAtom = atom(null, (get, set, values: InventoryItem[]) => {
  set(subscriptionHistoryAtom, uniqBy([...get(subscriptionHistoryAtom), ...values].filter(item => SUBSCRIPTION_CATEGORY_IDS.some(categoryId => item.categoryId === categoryId)), 'dateValidUntil'));
});
export const lastSubscriptionNudgeHasShownTimeAtom = getAtomWithStorage<Date | null>(LOCAL_STORAGE_KEY_LAST_NUDGE_TOAST_HAS_SHOWN_TIME, null, {
  reviver: reviveDateFromStorage
});
export const checkoutSubscriptionIdAtom = getAtomWithSessionStorage<string | null>('checkoutSubscriptionId', null);
export interface CheckoutEventContext {
  button_type: string;
  current_page_id: string;
  initial_feature?: string;
  initial_page_id?: string;
  is_intro_price_displayed: boolean;
  land_from: string;
  product_id: string;
}
export const checkoutEventContextAtom = getAtomWithSessionStorage<CheckoutEventContext | null>('checkoutEventContext', null);